import http from '@/http'

const adminUsersApiService = {
  /**
   * Get all admin users with pagination and filters
   */
  async getAdminUsers(page = 1, search = null, roleId = null, isActive = null) {
    const params = { page }
    if (search) {
      params.search = search
    }
    if (roleId) {
      params.role_id = roleId
    }
    if (isActive !== null) {
      params.is_active = isActive
    }
    return http.get('/admin/users', { params })
  },

  /**
   * Get a single admin user by ID
   */
  async getAdminUser(id) {
    return http.get(`/admin/users/${id}`)
  },

  /**
   * Create a new admin user
   */
  async createAdminUser(data) {
    return http.post('/admin/users', data)
  },

  /**
   * Update an admin user
   */
  async updateAdminUser(id, data) {
    return http.put(`/admin/users/${id}`, data)
  },

  /**
   * Delete an admin user
   */
  async deleteAdminUser(id) {
    return http.delete(`/admin/users/${id}`)
  },

  /**
   * Get all clients
   */
  async getClients() {
    return http.get('/admin/users/clients')
  },

  /**
   * Generate impersonation token for an admin user
   */
  async generateImpersonationToken(targetAdminUserId) {
    return http.post('/admin/impersonation/generate-token', {
      target_admin_user_id: targetAdminUserId,
    })
  },

  /**
   * Validate impersonation token and get auth token
   */
  async validateImpersonationToken(token) {
    return http.post('/admin/impersonation/validate', { token })
  },

  /**
   * End impersonation session
   */
  async endImpersonation() {
    return http.post('/admin/impersonation/end')
  },
}

export default adminUsersApiService
